export const CHART_VARIANTS = [
    { id: 'line', label: 'Line', icon: 'fas fa-chart-line', apexType: 'line', family: 'xy' },
    { id: 'area', label: 'Area', icon: 'fas fa-chart-area', apexType: 'area', family: 'xy' },
    { id: 'bar-horizontal', label: 'Bar (Horizontal)', icon: 'fas fa-align-left', apexType: 'bar', horizontal: true, family: 'xy' },
    { id: 'column', label: 'Column (Vertical)', icon: 'fas fa-chart-bar', apexType: 'bar', horizontal: false, family: 'xy' },
    { id: 'donut', label: 'Donut', icon: 'fas fa-circle-notch', apexType: 'donut', family: 'labeled' },
    { id: 'pie', label: 'Pie', icon: 'fas fa-chart-pie', apexType: 'pie', family: 'labeled' },
    { id: 'polarArea', label: 'Polar Area', icon: 'fas fa-compass', apexType: 'polarArea', family: 'labeled' },
    { id: 'radialBar', label: 'Radial Bar', icon: 'fas fa-record-vinyl', apexType: 'radialBar', family: 'labeled' },
    { id: 'radar', label: 'Radar', icon: 'fas fa-braille', apexType: 'radar', family: 'radar' },
    { id: 'scatter', label: 'Scatter', icon: 'fas fa-ellipsis-h', apexType: 'scatter', family: 'points' },
    { id: 'bubble', label: 'Bubble', icon: 'fas fa-circle', apexType: 'bubble', family: 'points' },
    { id: 'heatmap', label: 'Heatmap', icon: 'fas fa-th', apexType: 'heatmap', family: 'heatmap' },
    { id: 'combo', label: 'Combo (Bar + Line)', icon: 'fas fa-layer-group', apexType: 'line', family: 'xy' },
];

const HOURS = ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00'];
const DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const PHASES = ['R Phase', 'Y Phase', 'B Phase'];

export function getChartDemoData(variantId) {
    switch (variantId) {
        case 'bar-horizontal':
        case 'column':
            return { categories: DAYS, series: [{ name: 'kWh', data: [120, 132, 101, 134, 90, 60, 70] }] };
        case 'donut':
        case 'pie':
        case 'polarArea':
            return { labels: ['Lighting', 'HVAC', 'Motors', 'Other'], series: [44, 55, 13, 33] };
        case 'radialBar':
            return { labels: ['Load'], series: [67] };
        case 'radar':
            return { categories: PHASES, series: [{ name: 'THD %', data: [3.2, 2.8, 4.1] }] };
        case 'scatter':
            return { series: [{ name: 'Samples', data: [[10, 20], [15, 35], [20, 15], [25, 45], [30, 25], [35, 55]] }] };
        case 'bubble':
            return { series: [{ name: 'Load', data: [[10, 20, 15], [15, 35, 25], [20, 15, 10], [25, 45, 30]] }] };
        case 'heatmap':
            return {
                series: [
                    { name: '18-24', data: [{ x: 'Mon', y: 40 }, { x: 'Tue', y: 38 }, { x: 'Wed', y: 42 }, { x: 'Thu', y: 45 }, { x: 'Fri', y: 50 }] },
                    { name: '12-18', data: [{ x: 'Mon', y: 80 }, { x: 'Tue', y: 85 }, { x: 'Wed', y: 78 }, { x: 'Thu', y: 90 }, { x: 'Fri', y: 88 }] },
                    { name: '06-12', data: [{ x: 'Mon', y: 60 }, { x: 'Tue', y: 65 }, { x: 'Wed', y: 55 }, { x: 'Thu', y: 70 }, { x: 'Fri', y: 75 }] },
                    { name: '00-06', data: [{ x: 'Mon', y: 20 }, { x: 'Tue', y: 30 }, { x: 'Wed', y: 25 }, { x: 'Thu', y: 40 }, { x: 'Fri', y: 35 }] },
                ],
            };
        case 'combo':
            return {
                categories: DAYS,
                series: [
                    { name: 'Actual (kWh)', type: 'column', data: [120, 132, 101, 134, 90, 60, 70] },
                    { name: 'Target (kWh)', type: 'line', data: [110, 115, 115, 120, 100, 80, 80] },
                    { name: 'Previous Week (kWh)', type: 'line', data: [100, 108, 96, 118, 88, 55, 65] },
                ],
            };
        case 'line':
        case 'area':
        default:
            return { categories: HOURS, series: [{ name: 'kWh', data: [30, 40, 35, 50, 49, 60, 70, 91, 60, 45, 50, 40] }] };
    }
}
